export default "__VITE_ASSET__CExQpoKh__"